<script>
  import { v4 as uuidv4 } from "uuid";
  import request from "superagent";
  import { useQueryClient } from "@sveltestack/svelte-query";
  import { _ } from "svelte-i18n";

  import LoginOrCreateUser from "./LoginOrCreateUser.svelte";
  import OlympiatoppenConnection from "./OlympiatoppenConnection.svelte";
  export let newUser;
  export let edit;
  export let user;

  const queryClient = useQueryClient();

  let backup = [];
  let days = [];
  let sessions = [];

  let storedDays = localStorage.getItem("days");
  days = storedDays !== null ? JSON.parse(storedDays) : [];
  let daysWithoutVersion = days.filter(
    (item) => item.version === undefined
  ).length;

  let storedSessions = localStorage.getItem("sessions");
  sessions = storedSessions !== null ? JSON.parse(storedSessions) : [];
  let sessionsWithoutVersion = sessions.filter(
    (item) => item.version === undefined
  ).length;

  async function sendDay(day, entry) {
    if (day.version !== undefined) {
      console.log("[WARN] Tried to send day parameters with version", day);
      return;
    }
    try {
      const response = await request
        .post("/api/days")
        .set("Authorization", "Bearer " + user.id)
        .set("Content-Type", "application/json")
        .send(day);
      backup = backup.map((item) =>
        item.id === entry.id ? { ...item, daysSent: item.daysSent + 1 } : item
      );
      let storedInLocalStorage = localStorage.getItem("days");
      let parsedContent =
        storedInLocalStorage !== null ? JSON.parse(storedInLocalStorage) : [];
      daysWithoutVersion = parsedContent.filter(
        (item) => item.version === undefined
      );
      days = localStorage.setItem(
        "days",
        JSON.stringify(
          parsedContent.map((item) =>
            item.reference === response.body.reference &&
            item.id === response.body.id
              ? { ...item, version: response.body.version }
              : item
          )
        )
      );
      queryClient.invalidateQueries("days");
    } catch (error) {
      console.log("[ERROR] Could not send day parameters, got", error);
      backup = backup.map((item) =>
        item.id === entry.id ? { ...item, errorDays: item.errorDays + 1 } : item
      );
    }
  }

  async function backupDays(days, entry) {
    for (const day of days) {
      console.log("[BACKUP] Send day ", day);
      await sendDay(day, entry);
    }
  }

  async function sendSession(session, entry) {
    if (session.version !== undefined) {
      console.log("[WARN] Tried to send session with version", session);
      return;
    }
    try {
      const response = await request
        .post("/api/sessions")
        .set("Authorization", "Bearer " + user.id)
        .set("Content-Type", "application/json")
        .send(session);

      backup = backup.map((item) =>
        item.id === entry.id
          ? { ...item, sessionsSent: item.sessionsSent + 1 }
          : item
      );
      let storedInLocalStorage = localStorage.getItem("sessions");
      let parsedContent =
        storedInLocalStorage !== null ? JSON.parse(storedInLocalStorage) : [];

      sessionsWithoutVersion = parsedContent.filter(
        (item) => item.version === undefined
      );

      sessions = localStorage.setItem(
        "sessions",
        JSON.stringify(
          parsedContent.map((item) =>
            item.reference === response.body.reference &&
            item.id === response.body.id
              ? { ...item, version: response.body.version }
              : item
          )
        )
      );
      queryClient.invalidateQueries("sessions");
    } catch (error) {
      console.log("[ERROR] Could not send session, got", error);
      backup = backup.map((item) =>
        item.id === entry.id
          ? { ...item, errorSessions: item.errorSessions + 1 }
          : item
      );
    }
  }

  async function backupSessions(session, entry) {
    for (const session of sessions) {
      console.log("[BACKUP] Send session ", session);
      await sendSession(session, entry);
    }
  }

  function sendUserData() {
    let storedDays = localStorage.getItem("days");
    let daysWithoutVersion = (
      storedDays !== null ? JSON.parse(storedDays) : []
    ).filter((item) => item.version === undefined);
    let storedSessions = localStorage.getItem("sessions");
    let sessionsWithoutVersion = (
      storedSessions !== null ? JSON.parse(storedSessions) : []
    ).filter((item) => item.version !== undefined);
    const backupEntry = {
      id: uuidv4(),
      timestamp: new Date(),
      days: daysWithoutVersion.length,
      sessions: sessionsWithoutVersion.length,
      daysSent: 0,
      sessionsSent: 0,
      errorDays: 0,
      errorSessions: 0,
    };

    backup = backup.concat(backupEntry);

    backupDays(daysWithoutVersion, backupEntry);
    backupSessions(sessionsWithoutVersion, backupEntry);
  }
</script>

<div class="layout__item">
  <h1 class="layout__title">{$_("profile.myInfo")}</h1>
  {#if user.id}
    <div class="card">
      <section class="card__section card__section--inverse">
        <h2>
          {(user.name + " " + user.surname).trim().length === 0
            ? "(ditt navn)"
            : user.name + " " + user.surname}
        </h2>
      </section>
      <section class="card__section">
        <ul>
          <li>{user.email}</li>
          <li>{user.phone}</li>
        </ul>
      </section>
      <section class="card__section">
        <h3 class="h4">{$_("profile.sport")}</h3>
        <ul class="list-bullets">
          <li>Kunstløp</li>
          <li>Norges Skøyteforbund</li>
          {#if user.club !== undefined && user.club.trim().length > 0}<li>
              {user.club}
            </li>
          {/if}
        </ul>
        {#if user.rinkResults}
          <nav class="nav-list-links">
            <a
              href="https://www.rinkresults.com/skater?skater_id={user
                .rinkResults.id}"
              target="_blank"
              >RinkResults: {user.name}
              {user.rinkResults.club.name}, {user.rinkResults.nation}</a
            >
          </nav>
        {/if}
      </section>
      <section class="card__section">
        <a
          on:click|preventDefault={edit}
          class="button button--icon button--icon-edit"
          href="/minside/endre-informasjon">{$_("generic.buttons.change")}</a
        >
      </section>
    </div>
    <OlympiatoppenConnection {user} />

    {#if daysWithoutVersion > 0 || sessionsWithoutVersion > 0}
      <h1 class="layout__title">{$_("profile.securityCopy.title")}</h1>
      <div class="card">
        {#if backup.length > 0}
          <section class="card__section">
            {#each backup as item}
              <li>
                {item.timestamp.toLocaleString()}
                {$_("profile.securityCopy.copied")}
                {#if item.days > 0}
                  {item.daysSent}
                  {$_("profile.securityCopy.of")}
                  {item.days}
                  {$_("profile.securityCopy.days")}
                  {#if item.errorDays > 0}
                    ({item.errorDays} {$_("profile.securityCopy.failed")})
                  {/if}
                {/if}
                {#if item.days > 0 && item.sessions > 0}
                  {$_("profile.securityCopy.and")}
                {/if}
                {#if item.sessions > 0}
                  {item.sessionsSent}
                  {$_("profile.securityCopy.of")}
                  {item.sessions}
                  {$_("profile.securityCopy.sessions")}
                  {#if item.errorSessions > 0}
                    ({item.errorSessions} {$_("profile.securityCopy.failed")})
                  {/if}
                {/if}
              </li>
            {/each}
          </section>
        {/if}
        <section>
          {#if daysWithoutVersion > 0 || sessionsWithoutVersion > 0}
            <ul style="padding-bottom:15px">
              {#if daysWithoutVersion > 0}
                <li>
                  {daysWithoutVersion}
                  {$_("profile.securityCopy.daysNotSaved")}
                </li>
              {/if}
              {#if sessionsWithoutVersion > 0}
                <li>
                  {sessionsWithoutVersion}
                  {$_("profile.securityCopy.sessionsNotSaved")}
                </li>
              {/if}
            </ul>
          {/if}
          <a
            on:click|preventDefault={sendUserData}
            class="button"
            href="/minside/endre-informasjon">{$_("profile.addCopy")}</a
          >
        </section>
      </div>
    {/if}
  {:else}
    <LoginOrCreateUser {newUser} bind:user />
  {/if}
</div>
